module.exports = __webpack_public_path__ + "media/images/about-logo-pf-f7633f9f5a3b9065420e53e452ac2872.png";